import React, { useRef } from "react";
import { ImagePlus, X } from "lucide-react";

type InventoryProductImageInputProps = {
  name: string;
  selectedImage: string;
  setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearImage: () => void;
};

export const InventoryProductImageInput: React.FC<InventoryProductImageInputProps> = ({
  name,
  selectedImage,
  setSelectedImage,
  handleChange,
  onClearImage,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handlePickImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    const file = files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedImage("");
    }

    handleChange(event);
    event.target.value = "";
  };

  const handleRemoveImage = () => {
    setSelectedImage("");
    onClearImage();
  };

  return (
    <div data-testid="inventory-product-image-input">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        name={name}
        onChange={handlePickImage}
        data-testid="inventory-product-image-file-input"
      />
      {selectedImage ? (
        <div className="relative inline-block">
          <img
            src={selectedImage}
            alt="Selected product"
            className="inventory-image-preview"
            data-testid="inventory-product-image-preview"
          />
          <button
            type="button"
            onClick={handleRemoveImage}
            className="inventory-image-remove"
            aria-label="Remove image"
            data-testid="inventory-product-image-remove"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="inventory-btn-upload"
          onClick={() => fileInputRef.current?.click()}
          data-testid="inventory-product-image-upload"
        >
          <ImagePlus className="h-4 w-4" />
          Upload image
        </button>
      )}
    </div>
  );
};
